import { Timestamp } from '@app/modules/service-data/types/service-data.types';
import { AnalysisType } from '@core/core.types';

export interface Scheme {
  id: string;
  name: string;
  analysisType: AnalysisType;
  fields: SchemeFields[];
  generated?: Timestamp;
  deactivated?: Timestamp;
}

export interface DexTemplate {
  id: string;
  name: string;
  deactivated: string;
}

export interface ProvisionScheme
  extends Omit<Scheme, 'generated' | 'deactivated'> {}

export const awbModels = {
  pregenerated: 'Pregenerated',
  dhlApi: 'DHL API',
};

export const awbCustomerReferenceNumbers = [
  { value: '954187211', label: '954187211 (Slovenia)' },
  { value: '449100277', label: '449100277 (Kosovo)' },
  { value: '985912499', label: '985912499 (Mexico)' },
  { value: '314117214', label: '314117214 (Croatia)' },
  { value: '967622695', label: '967622695 (Croatia)' },
];

export const awbDomesticOnlyCustomerReferenceNumbers = [
  { value: '412260630', label: '412260630 (Hungary)' },
];

export const awbDescriptions = [
  'Exempt human specimen',
  'UN3373 biological substance, Category B, 1 package',
];

export const dhlProducts = [
  {
    value: 'Medical express',
    label: 'medicalExpress',
  },
  {
    value: 'Express Worldwide',
    label: 'expressWorldWide',
  },
];

export const awbPackageDescriptions = {
  /* eslint-disable-next-line @typescript-eslint/naming-convention */
  'Exempt human specimen':
    'Exempt human specimen, Non Infectious, Non-Contagious',
  /* eslint-disable-next-line @typescript-eslint/naming-convention */
  'UN3373 biological substance, Category B, 1 package':
    'UN3373 Biological Substance, Category B, Non Infectious, Non-Contagious',
};

export const awbDomesticPackageDescriptions = [
  'Exempt human specimen',
  'Material de laboratorio',
];

export const awbDomesticDhlProductCode = [
  {
    value: 'N',
    label: 'N (Domestic Express)',
  },
  {
    value: 'O',
    label: 'O (Domestic 10:30)',
  },
];

export enum SchemeFields {
  'ff' = 'ff',
}
